import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'App';
import { loadEnvironments } from 'library/Apis';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import * as serviceWorker from 'serviceWorker';
import './index.scss';
import { SicrediLogo } from 'plataforma-fundacao-componentes';

document.cookie = 'cross-site-cookie=bar, SameSite=None, Secure';

const IeVersion = (): {
  ActingVersion: number;
  CompatibilityMode: boolean;
  IsIE: boolean;
  TrueVersion: number;
} => {
  /*Set defaults*/
  var value = {
    IsIE: false,
    TrueVersion: 0,
    ActingVersion: 0,
    CompatibilityMode: false,
  };

  /*Try to find the Trident version number*/
  var trident = navigator.userAgent.match(/Trident\/(\d+)/);
  if (trident) {
    value.IsIE = true;
    /*Convert from the Trident version number to the IE version number*/
    value.TrueVersion = parseInt(trident[1], 10) + 4;
  }

  /*Try to find the MSIE number*/
  var msie = navigator.userAgent.match(/MSIE (\d+)/);
  if (msie) {
    value.IsIE = true;
    /*Find the IE version number from the user agent string*/
    value.ActingVersion = parseInt(msie[1]);
  } else {
    /*Must be IE 11 in "edge" mode*/
    value.ActingVersion = value.TrueVersion;
  }

  /*If we have both a Trident and MSIE version number, see if they're different*/
  if (value.IsIE && value.TrueVersion > 0 && value.ActingVersion > 0) {
    /*In compatibility mode if the trident number doesn't match up with the MSIE number*/
    value.CompatibilityMode = value.TrueVersion !== value.ActingVersion;
  }
  return value;
};

const detectIE = () => {
  const ie = IeVersion();
  if (ie) {
    return ie.IsIE;
  }
  return false;
};

const notSupportedIEElements = (
  <div id='ie-not-supported'>
    <SicrediLogo />
    <br />
    Olá Associado, esta plataforma não possui suporte ao Internet Explorer.
    <br />
    Para que você tenha a melhor experiência indicamos o uso do{' '}
    <a
      href='https://www.google.com/intl/pt-BR/chrome/'
      target='_blank'
      rel='noopener noreferrer'
    >
      Google Chrome
    </a>
    .
  </div>
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

loadEnvironments().then((env) => {
  root.render(detectIE() ? notSupportedIEElements : <App env={env!} />);
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
